import { makeStyles } from '@mui/styles';
import { green, orange, red } from 'apollo-react/colors';
import classNames from 'classnames';
import React from 'react';

import { STATUSES } from '../../constants/export.constants';

const useStyles = makeStyles({
  pending: {
    color: orange,
  },
  fail: {
    color: red,
  },
  success: {
    color: green,
  },
});

const StatusCell = ({ row, column: { accessor } }) => {
  const classes = useStyles();
  const status = row[accessor];

  return (
    <div
      className={classNames(
        status === STATUSES.FAIL
          ? classes.fail
          : [STATUSES.COMPLETE, STATUSES.SUCCESS].includes(status)
          ? classes.success
          : status === STATUSES.PENDING
          ? classes.pending
          : status === STATUSES.CHECKED
          ? classes.pending
          : null
      )}
    >
      {status}
    </div>
  );
};

export default StatusCell;
